(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-band"] && !Shopify.designMode) return;
  try {
    
  if(!window.whBandReady){
    window.whBandReady=true;
    document.addEventListener('click',(event)=>{
      const a=event.target.closest('[data-wh-band-black]');
      if(!a)return;
      const b=document.querySelector('#collection .wh-catalog-controls [data-wh-color="black"]');
      if(b&&b.getAttribute('aria-pressed')!=='true')b.click();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-catalog"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click',event=>{const button=event.target.closest('[data-catalog-colour]');if(!button)return;const section=button.closest('.wh-catalog');section.querySelectorAll('[data-catalog-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));section.querySelectorAll('wh-shop-card').forEach(card=>card.selectColour?.(button.dataset.catalogColour));});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-collection"]) return;
  try {
    
  document.addEventListener('change',event=>{if(event.target.matches('.wh-sort-form select'))event.target.form.requestSubmit();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-header"]) return;
  try {
    
  if(!customElements.get('wh-site-header'))customElements.define('wh-site-header',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;this.controller=new AbortController();const opts={signal:this.controller.signal};this.addEventListener('toggle',event=>{if(!event.target.matches('details'))return;if(event.target.open){this.querySelectorAll('details').forEach(d=>{if(d!==event.target)d.open=false;});if(event.target.matches('.wh-header-search'))event.target.querySelector('input[type=search]')?.focus();}},true);document.addEventListener('keydown',e=>{if(e.key==='Escape'){const open=this.querySelector('details[open]');if(open){open.open=false;open.querySelector('summary').focus();}}},opts);document.addEventListener('click',e=>{if(!this.contains(e.target))this.querySelectorAll('details').forEach(d=>d.open=false);},opts);this.addEventListener('click',e=>{if(e.target.closest('.wh-menu-panel a'))this.querySelector('.wh-mobile-menu').open=false;});window.addEventListener('pageshow',()=>this.refreshCart(),opts);document.addEventListener('shopify:cart:lines-update',event=>{event.promise?.then(()=>this.refreshCart()).catch(()=>{});},opts);document.addEventListener('shopify:cart:discount-update',event=>{event.promise?.then(()=>this.refreshCart()).catch(()=>{});},opts);}
    disconnectedCallback(){this.controller?.abort();this.ready=false;}
    async refreshCart(){try{const response=await fetch(this.dataset.cartUrl+'.js',{headers:{Accept:'application/json'}});if(!response.ok)return;const cart=await response.json();this.querySelector('[data-wh-bag-count]').textContent=`(${cart.item_count})`;}catch{}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wh-pdp-editorial"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('wh-colour-editorial'))customElements.define('wh-colour-editorial',class extends HTMLElement{
    connectedCallback(){this.controller=new AbortController();document.addEventListener('shopify:product:select',event=>{if(String(event.product?.id).split('/').pop()!==this.dataset.productId)return;const option=event.selectedOptions?.find(o=>o.name.toLowerCase()===this.dataset.option);if(!option)return;this.querySelectorAll('[data-editorial-colour]').forEach(photo=>photo.hidden=photo.dataset.editorialColour!==option.value.toLowerCase());},{signal:this.controller.signal});}
    disconnectedCallback(){this.controller?.abort();}
  });

  } catch(e) { console.error(e); }
})();
})();
